import { useCategory } from 'src/hooks/useCategory';
import { type Category, CategoryContext } from 'src/stores/Category';
import type { LOCALE_TYPE } from 'src/types/locale';

type Props = {
  locale: LOCALE_TYPE;
  children: React.ReactNode;
};

export const CategoryProvider: React.FC<Props> = ({ children }) => {
  const { category } = useCategory();
  return <CategoryContext.Provider value={category ?? ({} as Category)}>{children}</CategoryContext.Provider>;
};
